export const TABS = {
    VIEW: { value: "VIEW", text: "내용 확인" },
    FORM: { value: "FORM", text: "입력" },
    FILE: { value: "FILE", text: "파일첨부" },
    SAVE: { value: "SAVE", text: "전송" },
    DONE: { value: "DONE", text: "완료" },
};
